import React, { Component } from 'react';
import { Redirect, Link, history } from "react-router-dom";
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';

import $ from 'jquery';
import 'react-datepicker/dist/react-datepicker.css';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import Form from "react-jsonschema-form";
import AutoComplete from 'material-ui/AutoComplete';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Select from "react-select";
const dataSourceConfig = {
    text: 'title',
    value: 'id',
};
const schema = {}
const uiSchema ={}

const formData = {
    Owner: [],
    Quarter: 'id',
    keyresult: [''],
    object:'',
};


class AddOKR extends Component {
    constructor(props) {
        super(props);
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            apiUrl: this.decryptconfigdata('apiUrl'),
            userId: has_local_data ? localdata.user_id : '',
            userAuthKey: has_local_data ? localdata.user_key : '',
            fields: {},
            errors: {},
            message: '',
            loading: false,
            form: false,
            schema:schema,
            uiSchema:uiSchema,
            formData:formData,
            fields: {},
            update: 0,
            quarter: '',
            year: '',
            objective: '',
            assign_to_new:'',
			assign_to_title:'',
            search: [],
            liveValidate:false,
            UiSchema: {},
            owner: '',
            page_name:'',
       }
       this.submitUser = this.submitUser.bind(this);
    //    this.handleChange = this.handleChange.bind(this);
       //this.handleKeyDown = this.handleKeyDown.bind(this);
   }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }

    handleUpdateInput = (searchText) => {
		if((typeof searchText == "undefined") || (searchText == "") || (typeof searchText !== "string")){
			searchText='';

            formData.Owner = [];

            this.setState({
                formData: formData
            })

            this.setState({
                owner_error_message: 'Please choose an owner'
            });
            
        }else{
            this.setState({
                owner_error_message: ''
            });
        }

        this.setState({searchText: searchText});
        //this.getOwner(searchText);
    };

    goBack() {
        window.location.href = '/snippets';
    }


    onNewRequest(chosenRequest, index) {
        formData.Owner = [chosenRequest.id];
        this.setState({
            formData: formData,
            ownername: chosenRequest.title
        })
    }    
    
    getOwner(searchText = '') {
        fetch(this.state.apiUrl + '/OkrRest/getOwner/userAuthKey/' + this.state.userAuthKey + '/searchText/' + searchText, {
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(this.state),
        })
        .then((Response) => Response.json())
        .then((findresponse) => {
        findresponse = this.decrypt(findresponse, 1);
        if (findresponse.code == 200) {
            this.setState({
                search: findresponse.assign_to,
                errorText: ''
            })
        } else {
            this.setState({ errorText: findresponse.msg })
        }
        })
    }
   
    // handleKeyDown(event){
    //     console.log(event.target.value);
    //     const {...rest} = event.formData;
    //     if(typeof rest.object==="string"){
    //         console.log(rest.object.length);
    //         if(rest.object.length > 10){
    //             //document.getElementById("root_object").disabled="true";
    //             return false;
    //         }
    //     }
    // }


    hideAlert(){
        this.setState({
            error_message: ''
        });
    }

    defaultErrors(errors) {
        console.log(errors);
        return errors.map(error => {
        if (error.name === "type") {
            error.message = ""
        }
        return error;
        });
    }

    transformErrors(formData, errors) {

        if (typeof formData.keyresult == 'undefined' || formData.keyresult.length == 0) {
            errors.keyresult.addError("Please add atleast one key result");
           
        }else {

            formData.keyresult.map(function(result,index) {
                if(!result){
                    errors.keyresult[index].addError("Please enter your keyresult");
                    
                }/*else if(result.match("^[a-zA-Z0-9 _.,'!()+=,@#$!&%*-:()?/]*$") == null){
                    errors.keyresult[index].addError("Please enter a valid key result");
                   
                }*/else if(!result.replace(/\s/g, '').length){
                    errors.keyresult[index].addError("Please enter your keyresult");
                    
                }
            })
        }
        
        var objective = formData.object;
        if (!objective) {
            errors.object.addError("Please enter your objective");
            
        }/*else if(objective.match("^[a-zA-Z0-9 _.,'!()+=,@#$!&%*-:()?/]*$") == null){
            errors.object.addError("Please enter a valid objective");

        }*/else if(!objective.replace(/\s/g, '').length){
            errors.object.addError("Please enter your objective");
        }

        if (formData.Owner.length == 0) {
            errors.Owner.addError("Please choose a Owner");
        }
        
        return errors;
        
    }

    submitUser(data) {

        let api_url = this.state.apiUrl + '/OkrRest/InsertOkrnew/userAuthKey/' + this.state.userAuthKey;
        
        if(this.state.update){
            data.formData.user_uuid = this.props.match.params.id;
            api_url = this.state.apiUrl + '/OkrRest/updateuser/userAuthKey/' + this.state.userAuthKey;
        }

        this.state.fields['formData'] = data.formData;

        this.setState({waiting:'loading'});

        this.setState({error_message: ''});

        fetch(api_url, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify({'formData': data.formData,'userId': this.state.userId}),
        }) 
        .then((response) => response.json())
        .then((result) => {
            result = this.decrypt(result, 1);
            if (result.code === 200) {
            
            let arg = 'owner=' + (result.userId) + '&quarter=' + (this.state.year +' '+ this.state.quarter)+ '&search=' + ('');
                window.location.href = '/listokr/?' + arg;

            } else {

                this.setState({
                    error_message: result.msg,
                    formData: data.formData,
                });
            }
            this.setState({waiting:''});
        })
        return false;
    }
    
    cancel(){
        window.location.reload();
    }
    isSet(iVal){
        console.log(iVal);
        return (iVal!=="" && iVal!=null && iVal!==undefined && typeof(iVal) != "undefined") ? 1 : 0;
    }
    ManageDynamicform() {
        this.setState({
            loading:true
        });

        fetch(this.state.apiUrl + '/OkrRest/ManageForm/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId,{
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
       .then((Response) => Response.json())
        .then((findresponse) => {
            findresponse = this.decrypt(findresponse, 1);
            
            //console.log(findresponse.form);

            formData.Owner = [findresponse.owner['id']];
            formData.Quarter = findresponse.quarter['quarter'];
            this.setState({
                schema:findresponse.form['schema'],
                uiSchema:findresponse.form['uiSchema'],
                quarter:findresponse.quarter['quarter'],
                year:findresponse.quarter['year'],
                formData:formData,
                searchText:findresponse.owner['name'],
                page_name:"OKR : " + findresponse.quarter['year'] + " " + findresponse.quarter['quarter']
            });

        })
    }
    onChange(event) {
        let fields = this.state.fields;
        fields[event.target.name] = event.target.value;
    }
    weekchange(event) {
        this.setState({
        week: event.target.value,
         }, function () {
       });
    }
    componentDidMount() {
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
        document.title = "Intranet | Add OKR";
        this.ManageDynamicform();
        this.getOwner();
    }
    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }
       
        return (
            <div>
                <Header brecum_name="ER" brecum_page="Add OKR"/>
                <div class="right_col">
                    <section class="intranet_body">
                        <div class="title mob"><HeaderMob page_name={this.state.page_name}  /></div>
                        <div class="row add_okr">
                            <div class = "row">

                                {this.state.error_message ? (<div className="alert alert-danger alert-dismissible" role="alert">{this.state.error_message} <a href="#" class="close" onClick={() => this.hideAlert()} >&times;</a></div>) : ''}

                                <div className="col-md-6">
                                <label>Owner<span class="star">*</span></label>
                                <div class="form-group filter" name="assign_to_new">
                                <MuiThemeProvider muiTheme={getMuiTheme()} class="form-control">
                                    <AutoComplete
                                        id="autocomplete"
                                        // onChange={(e) => this.UpdateKeyresult(item.attribute)}
                                        onUpdateInput={this.handleUpdateInput}
                                        onNewRequest={ this.onNewRequest.bind(this) }
                                        onClick={this.handleUpdateInput}
                                        fullWidth={true}
                                        placeholder="Type here to search"
                                        filter={AutoComplete.caseInsensitiveFilter}
                                        dataSource={this.state.search}
                                        dataSourceConfig={dataSourceConfig}
                                        errorStyle={{ bottom: 0 }}
                                        errorText={this.state.errorText}
                                        maxSearchResults={100}
                                        className="okr_search_box"
                                        searchText={this.state.searchText}
                                        openOnFocus = {true}
                                        menuStyle = {{maxHeight: '160px'}}
                                    />
                                </MuiThemeProvider>
                                </div>
                                {this.state.owner_error_message ? <ul class="error-detail bs-callout bs-callout-info"><li class="text-danger">{this.state.owner_error_message}</li></ul> : ""}
                            </div>

                            </div>

                            <div class = "row">
                                    <Form
                                    formData={this.state.formData}
                                    schema={this.state.schema}
                                    autocomplete="off"
                                    uiSchema={this.state.uiSchema}
                                    showErrorList={false}
                                    //onKeyDown={this.handleKeyDown} 
                                    // onChange={this.handleChange}
                                    // onChange={this.transformErrors}
                                    onSubmit={this.submitUser}
                                    validate={this.transformErrors}
                                    transformErrors={this.defaultErrors}
                                    noHtml5Validate={true}
                                    >
                                    <div class="add-cancel-btn">
                                        
                                        {this.state.waiting ?  <button type="button" id="add_user_btn" class="btn btn-sky disabled" ><div><i class="fa fa-spinner fa-spin"></i><span> Submitting</span></div></button> : <button type="submit"  class="btn btn-sky">
                                        Add OKR</button>}

                                        <button type="button" className="btn btn-blue" id="cancel_btn" onClick={() => this.cancel()} >Cancel</button>
                                    </div>
                                </Form>
                            </div>
                        </div>
                        </section>
                    </div>
                </div>
        )
    }
}
export default AddOKR;


// WEBPACK FOOTER //
// ./src/components/okr/addokr.js